import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseItemSaturationOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-saturation-option';
import {useAppSelector} from '@/hooks';

export function ImageBgSaturationOption(): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const updateSaturation = (saturation: number, undoable = true): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          imageBackgroundItemObject: {
            effects: {
              saturation,
            },
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemSaturationOption saturation={currentPageObject.background.details.imageBackgroundItemObject.effects.saturation} updateSaturation={updateSaturation} />;
}
